import React, { FC } from 'react'
import { TimePeriodData } from '../../../../types/timePeriodData'

interface ScoreboardDotsProps {
	timePeriods: TimePeriodData[]
	activeSlide: number
	onDotClick: (index: number) => void
}

const ScoreboardDots: FC<ScoreboardDotsProps> = ({ timePeriods, activeSlide, onDotClick }) => {
	return (
		<div className='flex justify-center gap-2'>
			{timePeriods.map((_, index) => (
				<div
					key={index}
					onClick={() => onDotClick(index)}
					className={`h-2 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-secondary-100-light focus:ring-opacity-50 ${
						index === activeSlide
							? 'bg-brand-secondary-100-light dark:bg-brand-primary-100-dark w-6'
							: 'bg-gray-300 hover:bg-gray-400 w-2 cursor-pointer'
					}`}
					role='tab'
				/>
			))}
		</div>
	)
}

export default ScoreboardDots
